import classnames from 'classnames'

import Fixture from '~/components/atoms/Fixture/Fixture'
import Link from '~/components/atoms/Link/Link'
import { ComponentTheme } from '~/components/themes'

import Container from '../Container/Container'
import Text, { TextSizes } from '../Text/Text'

import styles from './Breadcrumb.module.css'

export interface BreadcrumbProps {
  list: {
    title: string
    url?: string
    item: string
  }[]
  theme?: ComponentTheme
  verticalPadding?: boolean
  noPaddingBottom?: boolean
  testID?: string
  hidden?: boolean
  preserveCaps?: boolean
  transparent?: boolean
  negativeMargin?: boolean
}

export default function Breadcrumb({
  list,
  theme = ComponentTheme.primary,
  verticalPadding,
  noPaddingBottom,
  testID,
  hidden,
  preserveCaps,
  transparent,
  negativeMargin = false,
}: BreadcrumbProps) {
  return (
    <div
      className={classnames(
        hidden && styles.hidden,
        transparent && styles.transparent
      )}
    >
      <Fixture
        theme={theme}
        verticalPadding={verticalPadding}
        noPaddingBottom={noPaddingBottom}
      >
        <Container>
          <div
            className={classnames(
              styles.base,
              negativeMargin && styles.negativeMargin
            )}
            data-testid={testID}
          >
            <div className={styles.inner}>
              {list.map((crumb, idx) => (
                <div key={`skiplinks-${crumb.title}-${idx}`}>
                  <Text size={TextSizes.bodySml}>
                    {crumb.url ? (
                      <Link
                        href={crumb.url}
                        className={styles.link}
                        testID={testID && `link-${testID}`}
                        noPrefetch
                      >
                        {crumb.title}
                      </Link>
                    ) : (
                      <span
                        className={classnames(
                          styles.noLink,
                          preserveCaps && styles.noLinkPreserveCaps
                        )}
                        data-testid={testID && `no-link-${testID}`}
                      >
                        {crumb.title}
                      </span>
                    )}
                  </Text>
                </div>
              ))}
            </div>
          </div>
        </Container>
      </Fixture>
    </div>
  )
}
